import cookie from "./cookie";

const USER_INFO_EVENT = "reg-user-info-ready";
const SESSION_ID_COOKIE = "session_id";
const SESSION_KEY_COOKIE = "session_key";
const AGENT_ID_COOKIE = "agent_id";
const BREG_ID_COOKIE = "_breg-uid";
const USER_INFO_TIMEOUT = 2000;

/**
 * @returns Promise<Object> with 4 properties: session_id, session_key, agent_id, breg
 */
function getSessionInfo() {
    let sessionInfo = window._regUserInfo || _getSessionInfoFromCookies();

    if (sessionInfo) {
        return Promise.resolve(_formatUserInfo(sessionInfo));
    }

    return new Promise((resolve, reject) => {
        let userInfoEventListener;

        try {
            userInfoEventListener = ({ detail }) => {
                window.removeEventListener(USER_INFO_EVENT, userInfoEventListener);
                sessionInfo = detail;

                try {
                    resolve(_formatUserInfo(sessionInfo));
                } catch (e) {
                    return reject("exception in _formatUserInfo");
                }
            };

            window.addEventListener(USER_INFO_EVENT, userInfoEventListener);

            setTimeout(() => {
                //NOTE: This appears to be dead code. If we were to get into this
                //Timeout and fallback to cookies, and the cookies were present,
                //then we would have returned those earlier at L16-17.

                // give up on event and just use what we can get from cookies
                window.removeEventListener(USER_INFO_EVENT, userInfoEventListener);
                sessionInfo = _getSessionInfoFromCookies(true);
                resolve(_formatUserInfo(sessionInfo));
            }, USER_INFO_TIMEOUT);
        } catch (e) {
            window.removeEventListener(USER_INFO_EVENT, userInfoEventListener);

            return reject("exception in getSessionInfo");
        }
    });
}

function _getSessionInfoFromCookies(fallback = false) {
    const sessionId = cookie.get(document, SESSION_ID_COOKIE);
    const sessionKey = cookie.get(document, SESSION_KEY_COOKIE);
    const agentId = cookie.get(document, AGENT_ID_COOKIE);
    const userId = cookie.get(document, BREG_ID_COOKIE);

    if ((sessionId && sessionKey && agentId && userId) || fallback) {
        return { sessionId, sessionKey, agentId, userId };
    }

    return null;
}

function _formatUserInfo(info) {
    const { sessionId, sessionKey, agentId, userId } = info ?? {};
    const result = {};

    if (sessionId) {
        result["session_id"] = sessionId;
    }

    if (sessionKey) {
        result["session_key"] = sessionKey;
    }

    if (agentId) {
        result["agent_id"] = agentId;
    }

    if (userId) {
        result.breg = userId;
    }

    return result;
}

export default getSessionInfo;
